import Vue from 'vue'

Vue.filter('formatDateToLocale', function (value){
    let date_obj = new Date(Date.parse(value))
    return date_obj.toLocaleString('default', {day:'2-digit',month:'2-digit', year:'numeric'})
})
